"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiGetCourseMetaData = exports.apiGetCourseById = exports.apiDeleteCourse = exports.apiUpdateCourse = exports.apiCreateCourse = exports.apiGetCourses = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
/**
 * Get the courses of the currently logged in teacher.
 *
 * The courses will only contain the name and prefix and not
 * the students.
 * @returns the courses of the currently logged in teacher.
 */
const apiGetCourses = async () => {
    const { data } = await client_1.default.get('/courses/teacher-courses');
    return data;
};
exports.apiGetCourses = apiGetCourses;
/**
 * Create a course with the given name, prefix and number of students.
 * @param name the name of the course (4 to 32 characters)
 * @param noStudents the number of students (1-40)
 * @returns the newly created course with its students
 */
const apiCreateCourse = async (name, noStudents) => {
    const { data } = await client_1.default.post('/courses/create-course', {
        name,
        noStudents,
    });
    return data;
};
exports.apiCreateCourse = apiCreateCourse;
/**
 * Update the name of the course.
 * @param courseId the course to update
 * @param newName the new name of the course
 * @param allowExternalEmbeds allow or disallow students to use externalEmbeds, only used when a boolean, otherwise ignored
 * @returns the updated course
 */
const apiUpdateCourse = async (courseId, newName, allowExternalEmbeds) => {
    const dto = { newName };
    if (typeof allowExternalEmbeds === 'boolean') {
        dto.allowExternalEmbeds = allowExternalEmbeds;
    }
    const { data } = await client_1.default.put(`/courses/update-course/${courseId}`, dto);
    return data;
};
exports.apiUpdateCourse = apiUpdateCourse;
/**
 * Deletes the course, along with its students and all their submissions/notes/messages.
 * @param courseId the course to delete
 */
const apiDeleteCourse = async (courseId) => {
    try {
        await client_1.default.delete(`courses/delete-course/${courseId}`);
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiDeleteCourse = apiDeleteCourse;
/**
 * Get the course with the given id.
 * Will throw an error if the logged in teacher doesn't own the course.
 * @param courseId The course id to fetch
 * @returns the course with the given id.
 */
const apiGetCourseById = async (courseId) => {
    const { data } = await client_1.default.get(`/courses/get-by-id/${courseId}`);
    return data;
};
exports.apiGetCourseById = apiGetCourseById;
/**
 * Get the course meta-data based on the course id.
 * Will throw an error if logged in teacher doesn't own the course.
 * @param courseId the id of the corresponding course
 * @returns the metadata of the corresponding course
 */
const apiGetCourseMetaData = async (courseId) => {
    const { data } = await client_1.default.get(`/courses/get-course-meta-data/${courseId}`);
    return data;
};
exports.apiGetCourseMetaData = apiGetCourseMetaData;
//# sourceMappingURL=courses.js.map